import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";

import { supabase } from "@/integrations/supabase/client";
import { Logo, PAGE_CONTAINER } from "../components/site";
import { Button } from "@/components/ui/button";
import { accountHead } from "@/lib/klantaccount-shared";

export const Route = createFileRoute("/auth")({
  head: () => accountHead("Inloggen", "Log in bij je offerto-account voor aanvragen, offertes en berichten."),
  component: AuthPage,
});

function AuthPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [wachtwoord, setWachtwoord] = useState("");
  const [bezig, setBezig] = useState(false);
  const [fout, setFout] = useState("");
  const [herstel, setHerstel] = useState(false);

  async function onLogin(e: React.FormEvent) {
    e.preventDefault();
    setBezig(true);
    setFout("");
    if (herstel) {
      const { error } = await supabase.auth.resetPasswordForEmail(email.trim(), { redirectTo: `${window.location.origin}/wachtwoord-instellen` });
      setBezig(false);
      setFout(error ? "De e-mail kon niet worden verzonden. Probeer later opnieuw." : "Als er een account bestaat, ontvang je een link om je wachtwoord in te stellen.");
      return;
    }
    const { error } = await supabase.auth.signInWithPassword({
      email: email.trim(),
      password: wachtwoord,
    });
    setBezig(false);
    if (error) {
      setFout("Inloggen mislukt. Controleer je e-mailadres en wachtwoord.");
      return;
    }
    const { data: sessie } = await supabase.auth.getUser();
    const gebruikerId = sessie.user?.id;
    let isAdmin = false;
    if (gebruikerId) {
      const { data: rol } = await supabase.rpc("has_role", {
        _user_id: gebruikerId,
        _role: "admin",
      });
      isAdmin = rol === true;
    }
    void navigate({ to: isAdmin ? "/admin" : "/account" });
  }

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <header className="border-b border-border">
        <div className={`${PAGE_CONTAINER} py-5`}>
          <Logo />
        </div>
      </header>
      <main className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center px-4 py-16">
        <h1 className="text-2xl font-bold">{herstel ? "Wachtwoord vergeten" : "Inloggen"}</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          {herstel ? "Ontvang een link om je wachtwoord opnieuw in te stellen." : "Bekijk je aanvragen, offertes en berichten in je offerto-account."}
        </p>
        <form onSubmit={(e) => void onLogin(e)} className="mt-8 space-y-5">
          <label className="block">
            <span className="text-sm font-bold">E-mailadres</span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 h-12 w-full rounded-md border border-input px-4 outline-none focus:border-primary"
            />
          </label>
          {!herstel && <label className="block">
            <span className="text-sm font-bold">Wachtwoord</span>
            <input
              type="password"
              required
              value={wachtwoord}
              onChange={(e) => setWachtwoord(e.target.value)}
              className="mt-2 h-12 w-full rounded-md border border-input px-4 outline-none focus:border-primary"
            />
          </label>}
          {fout && <p className="text-sm font-medium text-destructive">{fout}</p>}
          <Button
            type="submit"
            disabled={bezig}
            className="w-full rounded-md bg-primary px-6 py-3 font-bold text-primary-foreground disabled:opacity-40"
          >
            {bezig ? "Bezig…" : herstel ? "Verstuur herstellink" : "Inloggen"}
          </Button>
          <Button type="button" variant="link" className="px-0" onClick={() => { setHerstel((v) => !v); setFout(""); }}>{herstel ? "Terug naar inloggen" : "Wachtwoord vergeten?"}</Button>
        </form>
      </main>
    </div>
  );
}
